<template>
    <div id="pageTable">
        <v-container grid-list-xl fluid>
            <StoreStepper current="users"></StoreStepper>
            <v-layout row wrap>
                <v-flex lg12>
                    <v-card>
                        <v-toolbar card color="white">
                            <v-text-field
                                    flat
                                    solo
                                    prepend-icon="search"
                                    placeholder="جستجو..."
                                    v-model="search"
                                    hide-details
                                    class="hidden-sm-and-down"
                            ></v-text-field>
                            <v-btn icon>
                                <v-icon>filter_list</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-divider></v-divider>
                        <v-card-text class="pa-0">
                            <v-data-table
                                    :headers="complex.headers"
                                    :search="search"
                                    :items="complex.items"
                                    :rows-per-page-items="[25,50,100,500,{text:'همه','value':-1}]"
                                    class="elevation-1"
                                    item-key="Name"
                                    select-all
                                    v-model="complex.selected"
                            >
                                <template slot="items" slot-scope="props">
                                    <td class="text-xs-center">
                                        <v-checkbox
                                                primary
                                                hide-details
                                                v-model="props.selected"
                                        ></v-checkbox>
                                    </td>
                                    <td class="text-xs-center">{{ props.item.user_id }}</td>
                                    <td class="text-xs-center">{{ props.item.name }}</td>
                                    <td class="text-xs-center">{{ toPersianDigit(props.item.mobile) }}</td>
                                    <td class="text-xs-center">
                                        <v-chip color="green" text-color="white" v-if="props.item.status === 1">
                                            تایید شده
                                        </v-chip>
                                        <v-chip color="blue" text-color="white" v-if="props.item.status === 0">
                                            تایید نشده
                                        </v-chip>
                                        <v-chip color="red" text-color="white" v-if="props.item.status === 2">
                                            مسدود شده
                                        </v-chip>
                                    </td>
                                    <td class="text-xs-center">{{ moneyFormat(String(props.item.balance)) }}</td>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
            <v-snackbar
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    :top="snackbar.y === 'top'"
                    :bottom="snackbar.y === 'bottom'"
                    :right="snackbar.x === 'right'"
                    :left="snackbar.x === 'left'"
                    :multi-line="snackbar.mode === 'multi-line'"
                    :vertical="snackbar.mode === 'vertical'"
                    v-model="snackbar.snackbar"
            >
                {{ snackbar.text }}
                <v-btn flat icon dark @click.native="snackbar.snackbar = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-snackbar>
        </v-container>
    </div>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';
import StoreStepper from '@/components/StoreStepper';
export default {
  components: {
    StoreStepper
  },
  data () {
    return {
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
      cities: [],
      stores: [],
      shop_name: '',
      search: '',
      complex: {
        selected: [],
        headers: [
          {
            text: 'شناسه‌ی کاربر',
            value: 'user_id',
            align: 'center'
          },
          {
            text: 'نام',
            value: 'name',
            align: 'center'
          },
          {
            text: 'موبایل',
            value: 'mobile',
            align: 'center'
          },
          {
            text: 'وضعیت',
            value: 'status',
            align: 'center'
          },
          {
            text: 'موجودی(﷼)',
            value: 'balance',
            align: 'center'
          },
        ],
        items: []
      }
    };
  },
  mounted () {
    this.axios.get('/reseller/z_city/')
      .then(response => {
        this.cities = response.data.Data;
        this.getStores();
      })
      .catch(error => {
        console.log(error);
        this.snackbar = HttpErrorToSnackbar(error);
      });
  },
  methods: {
    getData: function () {
      this.axios.get('/reseller/users/?store_id=' + this.$route.params.store_id)
        .then(response => {
          this.complex.items = response.data.data;
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    getStores: function () {
      this.axios.get('/reseller/stores/')
        .then(response => {
          this.stores = response.data.Data;
          this.shop_name = this.getStoreById(parseInt(this.$route.params.store_id, 10));
          this.getData();
        })
        .catch(error => {
          this.snackbar = HttpErrorToSnackbar(error);
        });
    },
    getCityById: function (id) {
      let i = this.cities.findIndex(c => c.id === id);
      if (i > -1) {
        return this.cities[i].name;
      }
      return '[تعیین نشده]';
    },
    getStoreById: function (id) {
      let i = this.stores.findIndex(c => c.shop_id === id);
      if (i > -1) {
        return this.stores[i].shop_name;
      }
      return '';
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/users/list.vue